module.exports = __webpack_public_path__ + "static/media/tuesday-in-spanish.5879ed7d.png";